import axios, { AxiosResponse } from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export type WhatsappProvider = 'dialog360' | 'vixiees';

export interface RegisterWhatsappTemplateRequest {
  provider: WhatsappProvider;
  name: string;
  code: string;
  minHoursToResend: number;
  isMarketing: boolean;
}

export async function registerWhatsappTemplate({
  provider,
  name,
  code,
  minHoursToResend,
  isMarketing,
}: RegisterWhatsappTemplateRequest): Promise<AxiosResponse> {
  const params = {
    provider,
    name,
    code,
    min_hours_to_resend: minHoursToResend,
    is_marketing: isMarketing,
  };
  const endpoint = `${API_URL}/api/crm/whatsapp-templates/`;

  return axios.post(endpoint, params);
}

export interface SendMassiveWhatsappRequest {
  file: File;
  code: string;
}

export async function sendMassiveWhatsapp({
  file,
  code,
}: SendMassiveWhatsappRequest) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('code', code);
  const endpoint = `${API_URL}/api/crm/whatsapp-templates/massive/`;

  return axios.post(endpoint, formData);
}

export async function listTemplates() {
  const endpoint = `${API_URL}/api/crm/whatsapp-templates/`;

  return axios.get(endpoint);
}
